<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="班组名称" prop="name" style="margin-right:15px">
        <el-input v-model="form.name" placeholder="请输入班组名称" />
      </el-form-item>
      <el-form-item label="力别" prop="forceTypeName" style="margin-right:15px">
        <el-select v-model="form.forceTypeName" placeholder="请选择力别  " clearable style="width:100%" @change="changeForceType($event)">
          <el-option
            v-for="item in forceTypeData"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="所属部门" prop="departmentCode" style="margin-right:15px">
        <departmentSelect ref="departmentSelect" @setDepartmentCode="setDepartmentCode" />
      </el-form-item>



    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import departmentSelect from "./departmentSelect";
export default {
  name: 'TeamEdit',
  components: {
    departmentSelect
  },
  data() {
    return {
      emptyForm: {},
      forceTypeData:[],

      form: {
        forceTypeCode:'',
        forceTypeName:'',
        code: '',
        name: '',
        partyGroupCode: '',
        departmentCode: ''
      },
      rules: {
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },  
        ],
        name: [
          { required: true, message: '请输入班组名称', trigger: 'blur' },  
        ],
        partyGroupCode: [
          { required: true, message: '请输入所属机构', trigger: 'blur' },  
        ],
        departmentCode: [
          { required: true, message: '请输入所属部门', trigger: 'blur' },  
        ],
        forceTypeName: [
          { required: true, message: '请选择力别', trigger: 'blur' }
        ]

      },
      departmentList: []
    }
  },
  created() {
    this.findDepartmentList()
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
    this.findForceType()

  },
  methods: {
    // 获取力别数据
    findForceType() {
      request({
        url: '/ntocc-wms-api/forceType/listForceType',
        method: 'get',
      }).then(response => {
        this.forceTypeData = response.data
      })
    },
    // 选择力别
    changeForceType(e){
      this.form.forceTypeCode = e

      const str = this.forceTypeData.find(i => i.code === e)
      this.form.forceTypeName = str.name

    },
    // 选择客户
    setDepartmentCode(value) {
      this.form.partyGroupCode = value[0]
      this.form.departmentCode = value[1]
    },
    // 查询部门
    findDepartmentList() {
      request({ url: `/ntocc-basic-api/department`, method: 'get' }).then(response => {
        this.departmentList = response.data.records
      })
    },
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({ url: `/ntocc-basic-api/team/${code}`, method: 'get' }).then(response => {
        this.form = response.data
        this.departmentSelectValue = []
        this.departmentSelectValue.push(this.form.partyGroupCode)
        this.departmentSelectValue.push(this.form.departmentCode)
        this.$refs.departmentSelect.setSelectValue(this.departmentSelectValue)
        this.changeForceType(this.form.forceTypeCode)
      })
    },
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form
          request({ url: '/ntocc-basic-api/team', method: 'put', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherEditMethod')
          }).then(() => {
              this.$refs['form'].resetFields()
              this.$refs.departmentSelect.setSelectValue('')
            })
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'edit')
    }

  }
}
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin:15px 0 15px 0;
        width: 175px;
        float: right;
    }
</style>
